import { AgendaModel } from "@api/models/agenda/AgendaModel";
import { ObjectRepository } from "@api/repositories/ObjectRepository";

export interface SessionManipulationServiceInterface {
    /**
     * Отправляет запрос для начала текущей сессии
     */
    startSession(sessionId: string): void;

    /**
     * Отправляет запрос для завершения текущей сессии
     */
    completeSession(sessionId: string): void;

    /**
     * Отправляет запрос для обновления времени начала текущей сессии
     * @param sessionId
     * @param beginAt
     */
    updateBeginTime(sessionId: string, beginAt: string): void;

    /**
     * Отправляет запрос для обновления времени конца текущей сессии
     * @param sessionId
     * @param endAt
     */
    updateEndTime(sessionId: string, endAt: string): void;

    /**
     * Отправляет запрос для установки значение isManualControl в true
     * @param sessionId
     * @param isManualControlled
     */
    setManualControl(sessionId: string, isManualControlled: boolean): void;

    /**
     * Запрос для смещения времени начала и окончания указанной
     * сессии на указанное кол-ва минут
     * @param session
     * @param timeOffset - time offset in minutes
     */
    setOffsetToSession(session: AgendaModel, timeOffset: number): void;
}

export class SessionManipulationService implements SessionManipulationServiceInterface {
    constructor(
        private schemaId: string,
        private readonly objectRepository: ObjectRepository
    ) {
    }

    startSession(sessionId: string) {
        this.objectRepository.update(this.schemaId, sessionId, {
            isClosed: false,
            isStarted: true
        });
    }

    completeSession(sessionId: string) {
        this.objectRepository.update(this.schemaId, sessionId, {
            isStarted: true,
            isClosed: true
        });
    }

    updateBeginTime(sessionId: string, beginAt: string) {
        this.objectRepository.update(this.schemaId, sessionId, { beginAt: beginAt });
    }

    async updateEndTime(sessionId: string, endAt: string) {
        await this.objectRepository.update(this.schemaId, sessionId, { endAt: endAt });
    }

    setManualControl(sessionId: string, isManualControlled: boolean) {
        this.objectRepository.update(this.schemaId, sessionId, { isManualControlled: isManualControlled, isStarted: isManualControlled });
    }

    setOffsetToSession(session: AgendaModel, timeOffset: number) {
        const newBeginAt = session.beginAt.plus({ minutes: timeOffset }).toISO();
        const newEndAt = session.endAt.plus({ minutes: timeOffset }).toISO();

        this.setTimeToSession(session.id, newBeginAt, newEndAt);
    }

    private async setTimeToSession(sessionId: string, beginAt: string, endAt: string) {
        await this.objectRepository.update(this.schemaId, sessionId, { beginAt, endAt });
    }
}